import { render, staticRenderFns } from "./pdfFrame.vue?vue&type=template&id=125043d6&scoped=true"
import script from "./pdfFrame.vue?vue&type=script&lang=js"
export * from "./pdfFrame.vue?vue&type=script&lang=js"
import style0 from "./pdfFrame.vue?vue&type=style&index=0&id=125043d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125043d6",
  null
  
)

export default component.exports